import { Box, Container, Divider, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const Footer: any = ({ culture }: { culture: string | undefined }) => {

    let elem = <Box className="spacer"></Box>;

    if (!culture || culture === 'en-US') {

        const { t } = useTranslation();
        elem = <>
            <Typography variant="caption" component="p" data-test-id="footer-required-by-law-text" gutterBottom>{t('Footer_text1')}</Typography>
            <Typography variant="caption" component="p" data-test-id="footer-patriot-act-text" gutterBottom>
                <a href="https://www.fincen.gov/resources/statutes-regulations/usa-patriot-act" target="_blank" data-test-id="footer-patriot-act-link">{t('Footer_linkText')}</a> {t('Footer_text2')}
            </Typography>
        </>;
    }
    
    return (

        <Box id="footer">
            <Container>
                <Divider orientation="horizontal" variant="fullWidth" />
                {elem}
            </Container>
        </Box>
    );
}

export default Footer;